<template>
  <!-- Sidebar Container -->
   <!-- z index increased due to calendar header on small screen -->
  <div class="relative z-[999]">
    <CstSidebar ref="sidebarRef" v-model:expanded="isExpanded" class="border-right-only">
      <!-- Expanded Header -->
      <template v-slot:head-expanded>
        <div
          class="flex items-center justify-between h-[4.4rem] bottom-border-only"
        >
          <div class="flex justify-between items-center w-full pl-4 ">
            <div v-if="canAccessTopHeader" class="flex items-center relative">
              <SplitButton color="secondary" size="sm" dropdown-menu-class="!z-[1000] !min-w-[150px]" @click="openNewSocialComposer">
                <img
                  class="w-4 h-4"
                  src="@src/assets/img/icons/compose-white.svg"
                  alt="Compose"
                />
                Compose Post
                <template v-slot:dropdown-icon>
                  <i class="far fa-chevron-down"></i>
                </template>

                <template v-slot:menu>
                  <DropdownItem class="flex items-center gap-2 group" @click="openBlogComposer">
                    <img
                    src="@src/modules/publisher/assets/blog-default.svg"
                    alt="icon"
                    class="h-5 w-5 group-hover:!hidden"
                  />
                  <img
                    src="@src/modules/publisher/assets/blog-hover.svg"
                    alt="icon"
                    class="hidden h-5 w-5 group-hover:!block"
                  />
                     Blog Post
                  </DropdownItem>
                </template>
              </SplitButton>
            </div>
            <div v-else class="flex-grow"></div>
            <!-- Header Content -->
            <CstButton
              v-tooltip="'Collapse'"
              variant="text"
              size="small"
              class="group"
              @click="sidebarRef?.toggleExpand()"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.9998 9.99996C15.9998 10.3681 15.7013 10.6666 15.3332 10.6666H6.27598L9.80457 14.1952C10.0649 14.4556 10.0649 14.8777 9.80457 15.1381C9.54422 15.3984 9.12212 15.3984 8.86177 15.1381L4.1951 10.4714C4.06509 10.3413 4 10.171 3.99984 10.0006V16.6666C3.99984 17.0348 3.70136 17.3333 3.33317 17.3333C2.96498 17.3333 2.6665 17.0348 2.6665 16.6666V3.33329C2.6665 2.96511 2.96498 2.66663 3.33317 2.66663C3.70136 2.66663 3.99984 2.96511 3.99984 3.33329V10.0006C4 9.83021 4.06509 9.65856 4.1951 9.52855L8.86177 4.86189C9.12212 4.60153 9.54422 4.60153 9.80457 4.86189C10.0649 5.12224 10.0649 5.54435 9.80457 5.80469L6.27598 9.33329H15.3332C15.7013 9.33329 15.9998 9.63177 15.9998 9.99996Z"
                  class="fill-[#979CA0] group-hover:fill-[#4A4A4A]"
                />
              </svg>
            </CstButton>
          </div>
        </div>
      </template>

      <!-- Shrunk Header -->
      <template v-slot:head-shrink>
        <div
          class="flex items-center justify-center h-[4.40rem] bottom-border-only"
        >
          <div class="rotate-180">
            <!-- Header Content Shrink -->
            <CstButton
              v-tooltip="'Expand'"
              variant="text"
              size="small"
              class="group"
              @click="sidebarRef?.toggleExpand()"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.9998 9.99996C15.9998 10.3681 15.7013 10.6666 15.3332 10.6666H6.27598L9.80457 14.1952C10.0649 14.4556 10.0649 14.8777 9.80457 15.1381C9.54422 15.3984 9.12212 15.3984 8.86177 15.1381L4.1951 10.4714C4.06509 10.3413 4 10.171 3.99984 10.0006V16.6666C3.99984 17.0348 3.70136 17.3333 3.33317 17.3333C2.96498 17.3333 2.6665 17.0348 2.6665 16.6666V3.33329C2.6665 2.96511 2.96498 2.66663 3.33317 2.66663C3.70136 2.66663 3.99984 2.96511 3.99984 3.33329V10.0006C4 9.83021 4.06509 9.65856 4.1951 9.52855L8.86177 4.86189C9.12212 4.60153 9.54422 4.60153 9.80457 4.86189C10.0649 5.12224 10.0649 5.54435 9.80457 5.80469L6.27598 9.33329H15.3332C15.7013 9.33329 15.9998 9.63177 15.9998 9.99996Z"
                  class="fill-[#979CA0] group-hover:fill-[#4A4A4A]"
                />
              </svg>
            </CstButton>
          </div>
        </div>
      </template>

      <!-- Expanded Body -->
      <template v-slot:body-expanded>
        <div class="px-3 pt-4 space-y-4">
           <!-- Planner -->
           <ListItem
           :selected="isPlannerRoute"
           class="text-sm flex items-center gap-[14px] group select-none !py-[7px]"
           :class="{
             '!font-medium': isPlannerRoute,
           }"
           @click="router.push({ name: plannerItem.route })"
         >
           <img
             :src="plannerItem.defaultIcon"
             alt="icon"
             class="group-hover:!hidden"
             :class="{
               '!hidden': isPlannerRoute,
             }"
           />
           <img
             :src="plannerItem.hoverIcon"
             alt="icon"
             class="hidden group-hover:!block"
             :class="{
               '!block': isPlannerRoute,
             }"
           />
           <div
             class="text-[#3A4557] font-normal group-hover:font-medium flex-1 truncate"
             :class="{
               '!font-medium': isPlannerRoute,
             }"
           >
             {{ plannerItem.name }}
           </div>
         </ListItem>

          <template v-if="canAccessTopHeader">
            <Collapsible button-class="cstu-bg-gray-100" :default-open="true">
              <template v-slot:trigger>
                <span class="font-medium">AI Content Library
                  <img
                  class="ml-2"
                  src="@src/assets/img/common/new_tag.svg"
                  alt="new-tag"
                  />
                </span>
              </template>
              <!-- Body -->
              <div class="pt-1 space-y-2">
                <ListItem
                  v-for="item in contentLibraryItems"
                  :key="item.id"
                  :selected="currentRoute === item.route"
                  class="text-sm flex items-center gap-[14px] group select-none !py-[7px]"
                  :class="{
                    '!font-medium': currentRoute === item.route,
                  }"
                  @click="router.push({ name: item.route })"
                >
                  <img
                    :src="item.defaultIcon"
                    alt="icon"
                    class="group-hover:!hidden"
                    :class="{
                      '!hidden': currentRoute === item.route,
                    }"
                  />
                  <img
                    :src="item.hoverIcon"
                    alt="icon"
                    class="hidden group-hover:!block"
                    :class="{
                      '!block': currentRoute === item.route,
                    }"
                  />
                  <div
                    class="text-[#3A4557] font-normal group-hover:font-medium flex-1 truncate"
                    :class="{
                      '!font-medium': currentRoute === item.route,
                    }"
                  >
                    {{ item.name }}
                  </div>

                  <div
                    v-if="item?.count"
                    class="text-[#3A4557] text-xs leading-none font-normal group-hover:font-medium flex min-w-[35px] px-[10px] py-1 justify-center items-center gap-[10px] flex-shrink-0 rounded-[20px] bg-[#F7F7F7] group-hover:bg-[#D8EFFF]"
                    :class="{
                      '!bg-[#D8EFFF] !font-medium': currentRoute === item.route,
                    }"
                  >
                    {{ item?.count }}
                  </div>
                </ListItem>
              </div>
            </Collapsible>
          </template>

          <template v-if="canAccessTopHeader">
            <Collapsible button-class="cstu-bg-gray-100" :default-open="true">
              <template v-slot:trigger>
                <span class="font-medium">Automations</span>
              </template>
              <!-- Body -->
              <div class="pt-1 space-y-2">
                <ListItem
                  v-for="item in automationItems"
                  :key="item.id"
                  v-tooltip="hasAccess(item.featureKey) ? '' : getAccessErrorMessage(item.featureKey)"
                  :selected="currentRoute === item.route || isAutomationRoute(item.route)"
                  class="text-sm flex items-center gap-[14px] group select-none !py-[7px]"
                  @click="handleAutomationClick(item)"
                >
                  <img
                    :src="item.defaultIcon"
                    alt="icon"
                    class="group-hover:!hidden"
                    :class="{
                      '!hidden': currentRoute === item.route || isAutomationRoute(item.route),
                    }"
                  />
                  <img
                    :src="item.hoverIcon"
                    alt="icon"
                    class="hidden group-hover:!block"
                    :class="{
                      '!block': currentRoute === item.route || isAutomationRoute(item.route),
                    }"
                  />
                  <div
                    class="text-[#3A4557] font-normal group-hover:font-medium flex-1 truncate"
                    :class="{
                      '!font-medium': currentRoute === item.route || isAutomationRoute(item.route),
                    }"
                  >
                    {{ item.name }}
                  </div>

                  <div
                    v-if="item?.count"
                    class="text-[#3A4557] text-xs leading-none font-normal group-hover:font-medium flex min-w-[35px] px-[10px] py-1 justify-center items-center gap-[10px] flex-shrink-0 rounded-[20px] bg-[#F7F7F7] group-hover:bg-[#D8EFFF]"
                    :class="{
                      '!bg-[#D8EFFF] !font-medium': currentRoute === item.route || isAutomationRoute(item.route),
                    }"
                  >
                    {{ item?.count }}
                  </div>

                  <i v-if="!hasAccess(item.featureKey)" class="far fa-lock text-gray-800 text-xs"></i>
                </ListItem>
              </div>
            </Collapsible>

            <!-- Publishing Queue -->
             <Collapsible button-class="cstu-bg-gray-100" :default-open="true">
              <template v-slot:trigger>
                <span class="font-medium">Planner Settings</span>
              </template>
              <!-- Body -->
              <div class="pt-1 space-y-2">
                <ListItem
                  v-for="item in plannerSettingItems"
                  :key="item.id"
                  v-tooltip="item.tooltip ?  item.tooltip : ''"
                  :selected="currentRoute === item.route"
                  class="text-sm flex items-center gap-[14px] group select-none !py-[7px]"
                  @click="router.push(item.slug ? { name: item.route, params: { workspace: item.slug } } : { name: item.route })"
                >
                  <img
                    :src="item.defaultIcon"
                    alt="icon"
                    class="group-hover:hidden"
                    :class="{
                      '!hidden': currentRoute === item.route,
                    }"
                  />
                  <img
                    :src="item.hoverIcon"
                    alt="icon"
                    class="group-hover:!block hidden"
                    :class="{
                      '!block': currentRoute === item.route,
                    }"
                  />
                  <div
                    class="text-[#3A4557] font-normal group-hover:font-medium flex-1 truncate"
                    :class="{
                      '!font-medium': currentRoute === item.route,
                    }"
                  >
                    {{ item.name }}
                  </div>
                  <i v-if="item.navigation" class="far fa-external-link text-gray-700" aria-hidden="true"></i>
                </ListItem>
              </div>
            </Collapsible>
          </template>
        </div>
      </template>

      <!-- Shrunk Body -->
      <template v-slot:body-shrink>
        <div class="px-3 pt-1 space-y-4">
          <!-- Compose button -->
         <Dropdown
         v-if="canAccessTopHeader"
         placement="bottom-left"
         button-classes="border-none !p-0 !m-0 !ml-1 !my-2 !bg-transparent"
         dropdown-classes="w-24 !z-[1000]"
         size="xs"
         radius="md"
        :show-arrow="false"
         >
          <template v-slot:selected>
            <Button v-tooltip="'Compose Post'" class="!h-[35px]"  color="secondary" size="xs" >
              <img
                  class="w-4 h-4"
                  src="@src/assets/img/icons/compose-white.svg"
                  alt="Compose"
                />
            </Button>
          </template>

          <div class="">
            <DropdownItem
            v-for="action in composeActions"
            :key="action.id"
            size="sm"
            class="text-sm group"
            @click="action.action()"
          >
              <div class="flex items-center gap-4 ">
                <img :src="action.defaultIcon" alt="" class="w-5 h-5 group-hover:!hidden">
                <img :src="action.hoverIcon" alt="" class="w-5 h-5 hidden group-hover:!block">
                <div class="flex flex-col">
                  <span class="text-sm font-medium">{{ action.name }}</span>
                  <span class="text-xs text-gray-700">{{ action.description }}</span>
                </div>
              </div>
          </DropdownItem>
        </div>
        </Dropdown>
          <template v-for="(item, index) in getFilteredItems()" :key="index">
            <ListItem
              v-tooltip.right="item.featureKey ? (hasAccess(item.featureKey) ? item.name : getAccessErrorMessage(item.featureKey)) : item.name"
              :selected="currentRoute === item.route || (item.featureKey && isAutomationRoute(item.route)) || (item.route === plannerItem.route && isPlannerRoute)"
              class="text-sm flex items-center justify-center gap-[14px] group select-none relative"
              @click="item.featureKey ? handleAutomationClick(item) : router.push({ name: item.route })"
            >
              <img
                :src="item.defaultIcon"
                :alt="item.name"
                class="group-hover:hidden h-5 w-5"
                :class="{
                  '!hidden': currentRoute === item.route || (item.featureKey && isAutomationRoute(item.route)) || (item.route === plannerItem.route && isPlannerRoute),
                }"
              />
              <img
                :src="item.hoverIcon"
                :alt="item.name"
                class="group-hover:!block h-5 w-5 hidden"
                :class="{
                  '!block': currentRoute === item.route || (item.featureKey && isAutomationRoute(item.route)) || (item.route === plannerItem.route && isPlannerRoute),
                }"
              />
              <i v-if="item.featureKey && !hasAccess(item.featureKey)" class="far fa-lock text-gray-800 text-xs absolute top-0 right-0"></i>
            </ListItem>
          </template>
        </div>
      </template>
    </CstSidebar>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useFeatures } from '@modules/billing/composables/useFeatures'
import usePermissions from '@common/composables/usePermissions'
import { useBilling } from '@modules/billing/composables/useBilling'
import { useIcons } from '@modules/publisher/composables/useIcons'
import useWorkspace from '@common/composables/useWorkspace'
import { useSetup } from '@modules/publisher/ai-content-library/composables/useSetup'
import { useAIPostGeneration } from '@modules/publisher/ai-content-library/composables/useAIPostGeneration'
import CstSidebar from '@src/components/UI/Sidebar/CstSidebar.vue'
import CstButton from '@src/components/UI/Button/CstButton.vue'
import { Collapsible, ListItem, Dropdown, DropdownItem, Button, SplitButton } from '@contentstudio/ui'
import { useStore } from '@/src/store/base'

const {
    DefaultPostIcon,
    HoverPostIcon,
    DefaultProfileIcon,
    HoverProfileIcon,
    DefaultVideoIcon,
    HoverVideoIcon,
    DefaultArticleIcon,
    HoverArticleIcon,
    DefaultBulkUploadIcon,
    HoverBulkUploadIcon,
    DefaultEvergreenIcon,
    HoverEvergreenIcon,
    DefaultRSSIcon,
    HoverRSSIcon,
    DefaultPlannerIcon,
    HoverPlannerIcon,
    DefaultContentCategoryIcon,
    HoverContentCategoryIcon,
    SocialDefaultIcon,
    SocialHoverIcon,
    RedirectIcon,
    BlogDefaultIcon,
    BlogHoverIcon,
    SocialAccountDefaultIcon,
    SocialAccountHoverIcon } = useIcons()
const { AIUserProfile } = useSetup()
const { openNewSocialComposer, openBlogComposer } = useAIPostGeneration(AIUserProfile)
const router = useRouter()
const { getters } = useStore()
const { canAccess } = useFeatures()
const { showUpgradeModal } = useBilling()
const { hasPermission } = usePermissions()
const { getSuperAdmin } = useWorkspace()

// Check if user has access to top header
const canAccessTopHeader = computed(() => hasPermission('can_access_top_header'))

const getSuperAdminDetails = computed(() => getSuperAdmin())

const sidebarRef = ref(null)
const isExpanded = ref(true)

// list of sidebar items for AI Content Library
const contentLibraryItems = ref([
  {
    id: 1,
    name: 'AI Posts',
    defaultIcon: DefaultPostIcon,
    hoverIcon: HoverPostIcon,
    route: 'ai-content-library-posts',
  },
  {
    id: 2,
    name: 'Brand Settings',
    defaultIcon: DefaultProfileIcon,
    hoverIcon: HoverProfileIcon,
    route: 'ai-content-library-profile',
  },
])

// Planner
const plannerItem = ref(
  {
    id: 1,
    name: 'Planner',
    defaultIcon: DefaultPlannerIcon,
    hoverIcon: HoverPlannerIcon,
    route: 'planner'
  }
)

// list of sidebar items for Automations
const automationItems = computed(() => {
  const allItems = [
    {
      id: 1,
      name: 'Bulk Schedule',
      defaultIcon: DefaultBulkUploadIcon,
      hoverIcon: HoverBulkUploadIcon,
      route: 'save-bulk-csv-automation',
      featureKey: 'bulk_upload_csv'
    },
    {
      id: 2,
      name: 'Evergreen',
      defaultIcon: DefaultEvergreenIcon,
      hoverIcon: HoverEvergreenIcon,
      route: 'evergreen-automation-listing',
      featureKey: 'evergreen_recycling'
    },
    {
      id: 3,
      name: 'RSS Feed',
      defaultIcon: DefaultRSSIcon,
      hoverIcon: HoverRSSIcon,
      route: 'rss-automation-listing',
      featureKey: 'rss_scheduling'
    },
    {
      id: 4,
      name: 'Articles to Social Media',
      defaultIcon: DefaultArticleIcon,
      hoverIcon: HoverArticleIcon,
      route: 'article-social-automation-listing',
      featureKey: 'article_automation'
    },
    {
      id: 5,
      name: 'Videos to Social Media',
      defaultIcon: DefaultVideoIcon,
      hoverIcon: HoverVideoIcon,
      route: 'video-social-automation-listing',
      featureKey: 'video_automation'
    }
  ]

  // Filter based on super admin access flag
  if (getSuperAdminDetails.value && !getSuperAdminDetails.value.discovery_and_article_automation_access) {
    return allItems.filter(item => item.featureKey !== 'article_automation' && item.featureKey !== 'video_automation');
  }

  return allItems;
})

// list of compose actions
const composeActions = ref([
  {
    id: 1,
    name: 'Social Post',
    description: 'Create a social post',
    defaultIcon: SocialDefaultIcon,
    hoverIcon: SocialHoverIcon,
    action: openNewSocialComposer
  },
  {
    id: 2,
    name: 'Blog Post',
    description: 'Create a blog post',
    defaultIcon: BlogDefaultIcon,
    hoverIcon: BlogHoverIcon,
    action: openBlogComposer
  }
])

// list of sidebar items for Content Categories
const plannerSettingItems = ref([
  {
    id: 1,
    name: 'Content Categories',
    defaultIcon: DefaultContentCategoryIcon,
    hoverIcon: HoverContentCategoryIcon,
    route: 'content_categories-publisher'
  },
  {
    id: 2,
    name: 'Social Accounts',
    tooltip: 'Go to settings to manage your social accounts',
    navigation: true,
    defaultIcon: SocialAccountDefaultIcon,
    hoverIcon: SocialAccountHoverIcon,
    route: 'social',
    slug: getters.getActiveWorkspace.slug,
  }
])

// Function to check if a feature is accessible
const hasAccess = (featureKey) => {
  if (!featureKey) return true
  const accessRef = canAccess(featureKey)
  return accessRef?.value?.allowed || false
}

// Function to get access error message
const getAccessErrorMessage = (featureKey) => {
  if (!featureKey) return ''
  const accessRef = canAccess(featureKey)
  return accessRef?.value?.error?.message || 'Access denied'
}



const currentRoute = computed(() => {
  return router.currentRoute?.value?.name
})

// Check if the current route is related to planner
const isPlannerRoute = computed(() => {
  // Check if the current route name is 'planner' or contains 'planner'
  return currentRoute.value === 'planner' ||
         (typeof currentRoute.value === 'string' && currentRoute.value.includes('planner'))
})

// Check if the current route is related to automation
const isAutomationRoute = (itemRoute) => {
  // Map main routes to their related save/edit routes
  const routeMapping = {
    'evergreen-automation-listing': ['save-evergreen-automation', 'save-evergreen-automation-accounts', 'save-evergreen-automation-optimization', 'save-evergreen-automation-finalize'],
    'rss-automation-listing': ['save-rss-automation'],
    'article-social-automation-listing': ['save-article-social-automation'],
    'video-social-automation-listing': ['save-video-social-automation'],
    'save-bulk-csv-automation': []
  }

  // Check if current route exactly matches the menu item route
  if (currentRoute.value === itemRoute) {
    return true
  }

  // Check if current route is one of the related routes for this menu item
  if (routeMapping[itemRoute] && routeMapping[itemRoute].includes(currentRoute.value)) {
    return true
  }

  return false
}

// Handle click for automation items
const handleAutomationClick = (item) => {
  if (item.featureKey && !hasAccess(item.featureKey)) {
    showUpgradeModal()
  } else {
    router.push({ name: item.route })
  }
}

// Get filtered sidebar items based on permissions
const getFilteredItems = () => {
  if (canAccessTopHeader.value) {
    // Use the computed automationItems here
    return [ plannerItem.value,...contentLibraryItems.value, ...automationItems.value, ...plannerSettingItems.value]
  } else {
    return [plannerItem.value]
  }
}

</script>

<style>
.bottom-border-only {
  border-bottom: 1px solid #dee2e6 !important;
}
.border-x-only {
  border-left: 1px solid #dee2e6 !important;
  border-right: 1px solid #dee2e6 !important;
}
.border-right-only {
  border-right: 1px solid #dee2e6 !important;
}
</style>
